// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "220cf13",
    "hash": "220cf13",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "220cf13",
    "semverString": null,
    "version": "0.0.0",
    "time": 1635485998217
};
/* tslint:enable */
